var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDesktop)?_c('AsideMenuDesktop',{attrs:{"is-user-data-ready":_vm.isUserDataReady,"routes":_vm.routes}}):_c('MainMenuMobile',{attrs:{"is-user-data-ready":_vm.isUserDataReady,"routes":_vm.routes,"lock-scroll":true}})}
var staticRenderFns = []

export { render, staticRenderFns }